'use client'

import styled from 'styled-components'

import {
  Button,
  Skeleton,
  TypeStyleBodyDefault,
  TypeStyleHeadlineSmall,
  fromMd,
} from '@syconium/little-miss-figgy'

import { PageSection } from '../../pages/PageSection.client'

const desktopAspectRatio = 1.784
const mobileAspectRatio = 2.132

export const Wrapper = styled(PageSection)<{
  $backgroundColor: string
  $desktopTextAlign: 'left' | 'center'
  $textColor: string
}>`
  background: ${o => o.$backgroundColor};
  color: ${o => o.$textColor};
  text-align: center;
  width: 100%;

  ${fromMd} {
    display: flex;
    text-align: ${o => o.$desktopTextAlign};
  }
`

export const Content = styled.div<{
  $desktopWidth: '50%' | '100%'
  $mobileWidth: '50%' | '100%'
}>`
  padding: 20px ${o => o.theme.dimensions.layout.sidePadding.md}px;

  ${fromMd} {
    align-self: center;
    box-sizing: border-box;
    padding: ${o => o.theme.spacing(10)} calc(100% / 12) ${o => o.theme.spacing(5)} calc(100% / 12);
    width: ${o => o.$desktopWidth};
  }
`

export const ContentTitle = styled(TypeStyleHeadlineSmall).attrs({ asTag: 'h2' })``
export const ContentSubtitleWrapper = styled.div`
  display: flex;
  justify-content: center;
`
export const ContentSubtitle = styled(TypeStyleBodyDefault).attrs({ asTag: 'p' })`
  margin-top: ${o => o.theme.spacing(2)};

  ${fromMd} {
    font-size: 16px;
    margin-top: ${o => o.theme.spacing(5)};
    width: 849px;
  }
`

export const Cta = styled(Button)`
  margin-top: ${o => o.theme.spacing(4)};
`

export const ImageWrapper = styled.div<{
  $placement: string | null
}>`
  height: 0;
  order: ${o => (o.$placement === 'right' ? '2' : '-1')};
  overflow: hidden;
  padding-top: calc(1 / ${mobileAspectRatio} * 100%);
  position: relative;

  ${fromMd} {
    padding-top: calc(1 / ${desktopAspectRatio} * 50%);
    width: 50%;
  }

  & > img,
  & > picture > img,
  & > video {
    height: 100%;
    left: 0;
    object-fit: cover;
    font-family: 'object-fit: cover;';
    position: absolute;
    top: 0;
    width: 100%;
  }
`

export const SkeletonLoader = styled(Skeleton).attrs({ width: '100%', animated: true })`
  aspect-ratio: 1.4;
  ${fromMd} {
    aspect-ratio: ${desktopAspectRatio * 2};
  }
`
